/* tslint:disable */
/* eslint-disable */
export * from './AgeGroup';
export * from './BookedExamResponse';
export * from './BookedService';
export * from './CountryDto';
export * from './ExamDto';
export * from './ExamParticipantDto';
export * from './Horse';
export * from './HorseBreed';
export * from './HorseColor';
export * from './HorseRegister';
export * from './HorseRegisterDto';
export * from './HorseSearchResponseDto';
export * from './HorseSearchResultDto';
export * from './HorseUpdateDto';
export * from './IGVKennungRequest';
export * from './LoginRequestDto';
export * from './Person';
export * from './PersonRegisterDto';
export * from './PersonSearchResponseDto';
export * from './PersonSearchResultDto';
export * from './PersonUpdateDto';
export * from './RefreshRequestDto';
export * from './ServiceDto';
export * from './ShowScoreEntryDto';
export * from './ShowStarterDto';
export * from './Starter';
export * from './StarterDto';
export * from './StarterExmsDto';
export * from './StarterHistoryItemDto';
export * from './StarterResponse';
export * from './StarterServicesDto';
export * from './ShowScoreEntryDto';

export interface ExamDetailsDto {
  examId?: number | null
  examName?: string | null
  showName?: string | null
  scoringTypeName?: string | null
  type?: string | null
  linkedExams?: { examDisplayType?: number | null; linkText?: string | null; examId?: number | null }[] | null
  participants?: import('./ExamParticipantDto').ExamParticipantDto[] | null
}
export function ExamDetailsDtoFromJSON(json: any): ExamDetailsDto {
  if (json == null) return json
  return {
    examId: json['examId'] ?? null,
    examName: json['examName'] ?? null,
    showName: json['showName'] ?? null,
    scoringTypeName: json['scoringTypeName'] ?? null,
    type: json['type'] ?? null,
    linkedExams: Array.isArray(json['linkedExams'])
      ? json['linkedExams'].map((d: any) => ({ examDisplayType: d['examDisplayType'] ?? null, linkText: d['linkText'] ?? null, examId: d['examId'] ?? null }))
      : null,
    participants: Array.isArray(json['participants'])
      ? json['participants'].map((p: any) => ({
          startNo: p['startNo'] ?? null, startingOrder: p['startingOrder'] ?? null,
          startingGroup: p['startingGroup'] ?? null, startColor: p['startColor'] ?? null,
          place: p['place'] ?? null, horseName: p['horseName'] ?? null,
          horseRegisterId: p['horseRegisterId'] ?? null, horseBreed: p['horseBreed'] ?? null,
          horseBreedKz: p['horseBreedKz'] ?? null, horseBreeder: p['horseBreeder'] ?? null,
          horseOwner: p['horseOwner'] ?? null, riderFirstName: p['riderFirstName'] ?? null,
          riderLastName: p['riderLastName'] ?? null, riderRegisterId: p['riderRegisterId'] ?? null,
          result: p['result'] ?? null, resultsLocked: p['resultsLocked'] ?? null,
          choiceOfRein: p['choiceOfRein'] ?? null,
          riddenIn: Array.isArray(p['riddenIn']) ? p['riddenIn'].map((r: any) => ({ examDisplayType: r['examDisplayType'] ?? null, linkText: r['linkText'] ?? null, qualificationGrade: r['qualificationGrade'] ?? null })) : null,
          scores: Array.isArray(p['scores']) ? p['scores'] : null,
          igvPoints: p['igvPoints'] ?? null,
          canceled: p['canceled'] ?? null,
        }))
      : null,
  }
}

export interface ExamScheduleDateDto {
  examDisplayType?: number | null
  linkText?: string | null
  examId?: number | null
}
export interface ExamScheduleEntryDto {
  examNo?: number | null
  examName?: string | null
  scoringTypeName?: string | null
  countRider?: number | null
  linkedExams?: ExamScheduleDateDto[] | null
}
export function ExamScheduleEntryDtoFromJSON(json: any): ExamScheduleEntryDto {
  if (json == null) return json
  return {
    examNo: json['examNo'] ?? null,
    examName: json['examName'] ?? null,
    scoringTypeName: json['scoringTypeName'] ?? null,
    countRider: json['countRider'] ?? null,
    linkedExams: Array.isArray(json['linkedExams'])
      ? json['linkedExams'].map((d: any) => ({
          examDisplayType: d['examDisplayType'] ?? null,
          linkText: d['linkText'] ?? null,
          examId: d['examId'] ?? null,
        }))
      : null,
  }
}
